/* eslint-disable  @typescript-eslint/no-explicit-any */
/* eslint-disable no-console */

import { config } from "@/config";

export type LogAction = (message?: any, ...optionalParams: any[]) => void;

export interface Logger {
  trace: LogAction;
  debug: LogAction;
  info: LogAction;
  warn: LogAction;
  error: LogAction;
}

export const OmitLogAction: LogAction = () => {};

/**
 * log from "level" and higher
 *
 * order: "trace" = 0, "debug" = 1, "info" = 2, "warn" = 3, "error" = 4, "none" = 5
 *
 * not support: "fail"
 */
export class ConsoleLogger implements Logger {
  readonly trace: LogAction = console.trace.bind(console);
  readonly debug: LogAction = console.debug.bind(console);
  readonly info: LogAction = console.info.bind(console);
  readonly warn: LogAction = console.warn.bind(console);
  readonly error: LogAction = console.error.bind(console);

  private readonly hashMap = {
    trace: 0,
    debug: 1,
    info: 2,
    warn: 3,
    error: 4,
    none: 5,
  };

  constructor(level: LogLevel) {
    const rankLevel = this.hashMap[level as LogLevel];

    Object.keys(this.hashMap).forEach((key) => {
      const refinedKey = key as LogLevel;
      if (this.hashMap[refinedKey] < rankLevel) {
        (this as any)[refinedKey] = OmitLogAction;
      }
    });
  }
}

export const getLoggerLevel = () =>
  config.env === "prod"
    ? ("error" as LogLevel)
    : (config.logLevelConsole as LogLevel);

export const logger = new ConsoleLogger(getLoggerLevel());
